/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type TranslationProviderQueryVariables = {
    lang: string;
    prefixes?: Array<string | null> | null | undefined;
};
export type TranslationProviderQueryResponse = {
    readonly translationList: {
        readonly translations: ReadonlyArray<{
            readonly component: string | null;
            readonly text: string | null;
        } | null> | null;
    } | null;
};
export type TranslationProviderQuery = {
    readonly response: TranslationProviderQueryResponse;
    readonly variables: TranslationProviderQueryVariables;
};



/*
query TranslationProviderQuery(
  $lang: String!
  $prefixes: [String]
) {
  translationList(lang: $lang, prefixes: $prefixes) {
    translations {
      component
      text
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "lang"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "prefixes"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "lang",
        "variableName": "lang"
      },
      {
        "kind": "Variable",
        "name": "prefixes",
        "variableName": "prefixes"
      }
    ],
    "concreteType": "TranslationList",
    "kind": "LinkedField",
    "name": "translationList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Translation",
        "kind": "LinkedField",
        "name": "translations",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "component",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "text",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TranslationProviderQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TranslationProviderQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "395d241d4393822fadc51f6ac51a9ace",
    "id": null,
    "metadata": {},
    "name": "TranslationProviderQuery",
    "operationKind": "query",
    "text": "query TranslationProviderQuery(\n  $lang: String!\n  $prefixes: [String]\n) {\n  translationList(lang: $lang, prefixes: $prefixes) {\n    translations {\n      component\n      text\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '35ef87f34a70df24b65299227cbb9d35';
export default node;
